import React, { useEffect, useRef, useState } from "react";
import { View } from "react-native";
import TimeUnitDisplay from "./TimeUnitDisplay";
import diff from "date-fns/differenceInSeconds";
import parseISO from "date-fns/parseISO";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";

const MINUTE = 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

type CountDownTimerProps = {
    inDate?: string;
};

export const CountDownTimer = ({ inDate }: CountDownTimerProps): JSX.Element => {
    const styles = useDynamicStyles(generateStyles);
    const realSecondsRemaining = useRef(0);
    const [secondsRemaining, setSecondsRemaining] = useState(0);
    const days = Math.floor(Math.abs(secondsRemaining / DAY));
    let timeRemaining = secondsRemaining + DAY * days;
    const hours = Math.floor(Math.abs(timeRemaining / HOUR));
    timeRemaining += hours * HOUR;
    const minutes = Math.floor(Math.abs(timeRemaining / MINUTE));
    timeRemaining += minutes * MINUTE;

    // CM: Had a bunch of trouble here. Needed both the state and ref to get it working right.
    // If I only used the setState, when I tried to update the state with the callback function
    // It had the value of secondsRemaining when the interval was created.

    useEffect(() => {
        if (inDate) {
            realSecondsRemaining.current = diff(new Date(), parseISO(inDate));
            setSecondsRemaining(realSecondsRemaining.current);
        }
    }, [inDate]);

    useEffect(() => {
        const int = setInterval(() => {
            realSecondsRemaining.current++;
            setSecondsRemaining(realSecondsRemaining.current);
        }, 1000);
        return () => {
            clearInterval(int);
        };
    }, []);

    return (
        <View testID={"countdown"} style={styles.countdown}>
            <TimeUnitDisplay numeral={days} unit={days === 1 ? "Day" : "Days"} />
            <TimeUnitDisplay numeral={hours} unit={hours === 1 ? "Hour" : "Hours"} />
            <TimeUnitDisplay numeral={minutes} unit={minutes === 1 ? "Minute" : "Minutes"} />
            <TimeUnitDisplay
                numeral={Math.abs(timeRemaining)}
                unit={Math.abs(timeRemaining) === 1 ? "Second" : "Seconds"}
            />
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        countdown: {
            flexDirection: "row",
            alignSelf: "stretch",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 10,
            width: "100%",
        },
    });
};
